// extracted by mini-css-extract-plugin
module.exports = {"layoutBox":"About_layoutBox__aTKXx","center":"About_center__1IRri","title":"About_title__3Cjjq","flexList":"About_flexList__27UcZ"};